/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".domain-icon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%] {\n  border-radius: 10%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRvbWFpbi1pY29uLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFHRSxrQkFBa0I7QUFDcEIiLCJmaWxlIjoiZG9tYWluLWljb24uY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5kb21haW4taWNvbiBpbWcge1xuICAtd2Via2l0LWJvcmRlci1yYWRpdXM6IDEwJTtcbiAgLW1vei1ib3JkZXItcmFkaXVzOiAxMCU7XG4gIGJvcmRlci1yYWRpdXM6IDEwJTtcbn1cbiJdfQ== */"];
export { styles as styles };

